import * as React from "react";
import classNames from "classnames";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { InjectedTranslateProps, translate } from "react-i18next";

import Typography from "@material-ui/core/Typography";
import { conf } from "../../conf";
import {
	deactivateTableLinkMode,
	updateTableLinkGroups,
	updateSingleOccupiedDay
} from "../../actions/store/app-actions";
import { ConnectedInfobar } from "../layout/infobar";
import {
	saveTableLinkGroups,
	saveTableLinkGroupsAndUpdateStore
} from "../../actions/occupied-day-actions";
import { OccupiedDay } from "../../api/occupied-days";

export interface TableLinkInfobarProps {
	rootClass?: string;
}

interface ConnectedTableLinkInfobarProps extends WithStyles<typeof styles> {
	tempTableLinkGroups: string[][];
	tableLinkActiveGroup: number;
	tableLinkModeActive: boolean;
	tableLinkDeletionModeActive: boolean;
	deactivateTableLinkMode: (persist: boolean) => void;
	updateSingleOccupiedDay: (id: string, updateData: OccupiedDay) => void;
}

type Props = TableLinkInfobarProps &
	ConnectedTableLinkInfobarProps &
	InjectedTranslateProps;

export class TableLinkInfobar extends React.Component<Props, {}> {
	handleConfirmClick = async () => {
		saveTableLinkGroupsAndUpdateStore();
	};

	handleCancelClick = () => {
		this.props.deactivateTableLinkMode(false);
	};

	canRenderSaveButton = () => {
		const {
			tableLinkActiveGroup,
			tableLinkModeActive,
			tableLinkDeletionModeActive
		} = this.props;

		return (
			(tableLinkModeActive && tableLinkActiveGroup > -1) ||
			tableLinkDeletionModeActive
		);
	};

	renderMessages() {
		const {
			classes,
			tableLinkActiveGroup,
			tableLinkModeActive,
			tableLinkDeletionModeActive
		} = this.props;

		if (tableLinkModeActive && tableLinkActiveGroup === -1) {
			return (
				<Typography>
					Nicht verbundenen Tisch anklicken um neue Gruppe zu
					erstellen,
					<br />
					oder verbundenen Tisch anklicken um weitere Tische
					hinzuzufügen.
				</Typography>
			);
		} else if (tableLinkModeActive && tableLinkActiveGroup > -1) {
			return (
				<div className={classes.activeGroupInfoContainer}>
					<div className={classes.activeGroupInfoIconContainer}>
						<div
							className={classes.activeGroupInfoIcon}
							style={{
								backgroundColor:
									conf.linkGroupColors[tableLinkActiveGroup]
							}}
						/>
					</div>
					<div className={classes.activeGroupInfoContent}>
						<Typography>
							Gruppe aktiv!
							<br />
							Weitere Tische anklicken um sie der Gruppe
							zuzuweisen.
						</Typography>
					</div>
				</div>
			);
		} else if (tableLinkDeletionModeActive) {
			return (
				<Typography>
					Tische anklicken deren Verbindung aufgehoben werden soll.
				</Typography>
			);
		}

		return null;
	}

	render() {
		const {
			tableLinkModeActive,
			tableLinkDeletionModeActive,
			rootClass
		} = this.props;

		return (
			<ConnectedInfobar
				visible={tableLinkModeActive || tableLinkDeletionModeActive}
				renderSaveButton={this.canRenderSaveButton()}
				onSaveClick={this.handleConfirmClick}
				onCancelClick={this.handleCancelClick}
				rootClass={rootClass}
				zIndex={15}
			>
				{this.renderMessages()}
			</ConnectedInfobar>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	tempTableLinkGroups: state.tempTableLinkGroups,
	tableLinkActiveGroup: state.tableLinkActiveGroup,
	tableLinkModeActive: state.tableLinkModeActive,
	tableLinkDeletionModeActive: state.tableLinkDeletionModeActive
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	deactivateTableLinkMode: (persist: boolean) =>
		dispatch(deactivateTableLinkMode(persist)),
	updateSingleOccupiedDay: (id: string, updateData: OccupiedDay) =>
		dispatch(updateSingleOccupiedDay(id, updateData))
});

const styles = (theme: Theme) =>
	createStyles({
		activeGroupInfoContainer: {
			display: "flex",
			justifyConten: "center",
			alignItems: "center"
		},
		activeGroupInfoIconContainer: {
			paddingRight: 15
		},
		activeGroupInfoIcon: {
			width: 32,
			height: 32,
			borderRadius: "100%",
			backgroundColor: "#C5C5C5"
		},
		activeGroupInfoContent: {
			paddingLeft: 15,
			borderLeft: "1px solid lightgray"
		}
	});

export const ConnectedTableLinkInfobar = translate("translations")(
	withStyles(styles)(
		connect(
			mapStateToProps,
			mapDispatchToProps
		)(TableLinkInfobar)
	)
);
